import request from "@/utils/auth-net";
import request2 from "@/utils/request";
//通过code获取accessToken
export function getAccessTokenByCodeApi(code) {
    return request({
        url: "auth/getAccessToken?code=" + code,
        method: "get"
    });
}

// 通过accessToken获取用户信息
export function getUserInfoApi(accessToken) {
    return request({
        url: "auth/getUserInfo?accessToken=" + accessToken,
        method: "get"
    });
}

// 通过accessToken获取的用户信息获取userId
export function getUserIdApi(userInfo) {
    return request2({
        url: "/user/loginAuth",
        method: "post",
        data: userInfo
    });
}

// 通过accessToken获取的用户信息获取userId --法人
export function getUserIdApiCompany(userInfo) {
    return request2({
        url: "/user/loginAuthLegal",
        method: "post",
        data: userInfo
    });
}